import ReactGA from "react-ga4";

export const initGA = () => {
    ReactGA.initialize("G-RQYWB33VNR"); // Buraya kendi GA kodunu yaz
};

export const logPageView = (path: string) => {
    ReactGA.send({ hitType: "pageview", page: path });
};
